import ROLES from '@/utils/roles';
import TOP_BARS from '@topBars';
let routes = [
  /**
   * @description 老师端-学生申请
   * @function /info 老师端-学生申请
   * @param { Component } Info views/school/
   * @param { Name } pathname /school-student
   */
  {
    path: '/school-student',
    name: 'school-studentApply',
    meta: {
      title: '老师端'
    },
    component: () => import('../../views/school/')
  }
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    topBar: TOP_BARS.SCHOOL,
    role: ROLES.SCHOOL
  });
  return ret;
});
export default routes;
